import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["textarea"]
  }

  static get values() {
    return { content: String }
  }

  connect() {
    this.textareaTarget.value = this.contentValue
  }

  onInput() {
    this.dispatch("changed", {
      detail: { blockData: { block_content: this.textareaTarget.value } },
      prefix: "homer-block"
    })
  }
}
